import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Auth0ClientService } from '../../../core/services/auth0-client.service';
import { TeamService } from '../../../core/services/team.service';

@Component({
	selector: 'ticketing-auth0-callback',
	template: `
		<div class="auth0-callback-spinner">
			<spinner-loading [isLoading]="true" [loadingText]="'Signing you in…'"></spinner-loading>
			<div *ngIf="error" class="text-danger p-3">{{ error }}</div>
		</div>
	`,
	styles: ['.auth0-callback-spinner { text-align: center; padding: 64px 0; }']
})
export class Auth0CallbackComponent implements OnInit {
	public error: string | null = null;

	constructor(
		private auth0: Auth0ClientService,
		private http: HttpClient,
		private router: Router,
		private teamService: TeamService
	) {}

	async ngOnInit(): Promise<void> {
		const teamCode = this.teamService.teamTemplate ? this.teamService.teamTemplate.teamId : '';
		try {
			const appState = await this.auth0.handleRedirectCallback();
			const returnTo = (appState && (appState as any).returnTo)
				|| (teamCode ? `${teamCode}/main` : '');

			// Probe the API once to find out whether the Auth0 sub is already linked to a
			// customer record. The RequireLinkedCustomerFilter on the API responds with
			// HTTP 403 + ErrorCode=AUTH0_LINK_REQUIRED when linking is still needed.
			try {
				await this.http.get('core-api/Ticketing/Portals/GetPortalRequiredSettings').toPromise();
				await this.router.navigateByUrl(returnTo);
			} catch (err) {
				if (err instanceof HttpErrorResponse
					&& err.status === 403
					&& this.isLinkRequiredResponse(err)) {
					await this.router.navigateByUrl(`${teamCode}/auth0-link`, {
						state: { returnTo }
					} as any);
				} else {
					this.error = 'Sign-in completed but the server rejected the request. Please try again.';
				}
			}
		} catch (err) {
			this.error = 'Sign-in did not complete. Please try again.';
		}
	}

	private isLinkRequiredResponse(err: HttpErrorResponse): boolean {
		const body = err.error;
		if (!body) {
			return false;
		}
		const code = body.errorCode || body.ErrorCode || (body.data && body.data.errorCode);
		return code === 'AUTH0_LINK_REQUIRED';
	}
}
